import axios from 'axios';

export default async (id, data) => {
  return await axios
    .post(`v2/affiliates/${id}/reject-profile-info`, { reject_reason: data })
    .then(({ data: res }) => {
      return res;
    });
};
